import { render } from "./CoordinatorDashboard.vue?vue&type=template&id=1b168e3c&scoped=true"
import script from "./CoordinatorDashboard.vue?vue&type=script&lang=js"
export * from "./CoordinatorDashboard.vue?vue&type=script&lang=js"

import "./CoordinatorDashboard.vue?vue&type=style&index=0&id=1b168e3c&lang=scss&scoped=true"
import "./CoordinatorDashboard.vue?vue&type=style&index=1&id=1b168e3c&lang=css"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b168e3c"]])

export default __exports__